import GreyDownArrow from "@/assets/icons/greyDownArrow.png"
import { themes } from "@/constants/colors_v2";
import { RootState } from "@/store";
import { JSX, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Select, { components, SingleValue, PlaceholderProps } from "react-select";


interface OptionType {
    value: any;
    label: string;
}

export default function DropDown(props: any) {
    const [isDark, setIsDark] = useState(false)
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    useEffect(() => {
        if (currentTheme === themes.dark) {
            setIsDark(true)
        } else {
            setIsDark(isDark)
        }
    }, [currentTheme])

    const customStyles = {
        control: (provided: any) => ({
            ...provided,
            borderRadius: "5px",
            padding: props.paddingControl ? props.paddingControl : "4px 6px",
            boxShadow: "none",
            margin: "0px",
            fontSize: props.lableFontSize ? props.lableFontSize : "16px",
            width: props.width_ ? props.width_ : "100%",
            backgroundColor: props.readOnly
                ? (isDark ? "var(--gray-color21)" : "var(--white-color7)")
                : (isDark ? "var(--black-color)" : "var(--white-color)"),

            border: isDark ? "1px solid var(--gray-color4)" : "1px solid var(--white-color9)",

        }),
        menu: (provided: any) => ({
            ...provided,
            borderRadius: "5px",
            boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
            marginTop: 4,
            padding: 0,
            overflow: "hidden",
            fontSize: props.lableFontSize ? props.lableFontSize : "16px",
            border: isDark ? "1px solid var(--gray-color4)" : "1px solid var(--gray-color13)",
        }),
        menuList: (provided: any) => ({
            ...provided,
            padding: "0px",
        }),
        option: (provided: any, state: any) => ({
            ...provided,
            // borderBottom: state.data.value !== "female" ? "1px solid #e0e0e0" : "none",

            borderBottom: state.data.value !== "female" ? (isDark ? "1px solid var(--gray-color4)" : "1px solid var(--white-color9)") : "none",

            // backgroundColor: state.isFocused
            //     ? "#f5f5f5"
            //     : state.isSelected
            //         ? "#f5f5f5" // Keep #f5f5f5 when selected
            //         : "#fff",

            backgroundColor: state.isFocused
                ? (isDark ? "var(--black-color)" : "#f5f5f5")
                : state.isSelected
                    ? (isDark ? "var(--black-color)" : "#f5f5f5")
                    : (isDark ? "var(--gray-color21)" : "#fff"),

            color: isDark ? "var(--white-color)" : "var(--black-color4)",
            padding: "10px 15px",
            cursor: "pointer",

        }),
        singleValue: (provided: any) => ({
            ...provided,
            fontSize: props.lableFontSize ? props.lableFontSize : "16px",
            margin: "0px",
            color: isDark ? "var(--white-color)" : "var(--black-color4)",
        }),
        // placeholder: (provided: any) => ({
        //     ...provided,
        //     // Set the default placeholder color here for the text (e.g., "Country")
        //     color: '#9e9e9e', // A common grey color for placeholders
        // }),
    };

    // const customComponents2 = {
    //     IndicatorSeparator: () => null,
    //     DropdownIndicator: (props: any) => {
    //         const isMenuOpen = props.selectProps.menuIsOpen;

    //         return (
    //             <components.DropdownIndicator {...props}>
    //                 <img
    //                     src={GreyDownArrow}
    //                     alt="dropdown"
    //                     className={`w-[14px] transition-transform duration-200 ${isMenuOpen ? "rotate-180" : ""
    //                         }`}
    //                 />
    //             </components.DropdownIndicator>
    //         );
    //     },
    // };



    // const CustomPlaceholder = (placeholderProps: PlaceholderProps<OptionType, false>) => {
    //     return (
    //         <components.Placeholder {...placeholderProps}>
    //             {props.placeholder} {/* The main placeholder text (e.g., "Country") */}
    //             {true && ( // Conditionally render the red asterisk
    //                 <span style={{ color: 'red', marginLeft: '-1px' }}>*</span>
    //             )}
    //         </components.Placeholder>
    //     );
    // };

    const customComponents: {
        IndicatorSeparator: () => null;
        DropdownIndicator?: (props: any) => JSX.Element;
    } = {
        IndicatorSeparator: () => null,
    };

    // const customComponents: {
    //     IndicatorSeparator: () => null;
    //     DropdownIndicator?: (props: any) => JSX.Element;
    //     Placeholder?: (props: PlaceholderProps<OptionType, false>) => JSX.Element; // Define the Placeholder component type
    // } = {
    //     IndicatorSeparator: () => null,
    //     Placeholder: CustomPlaceholder, // Assign the custom placeholder component
    // };

    if (props.customDropDownIcon) {
        customComponents.DropdownIndicator = (dropdownProps: any) => {
            const isMenuOpen = dropdownProps.selectProps.menuIsOpen;

            return (
                <components.DropdownIndicator {...dropdownProps}>
                    <img
                        src={GreyDownArrow}
                        alt="dropdown"
                        className={`w-[14px] transition-transform duration-200 ${isMenuOpen ? "rotate-180" : ""
                            }`}
                    />
                </components.DropdownIndicator>
            );
        };
    }

    const handleChange = (
        newValue: SingleValue<OptionType>
    ) => {
        /*
        This is done to support the format other inputs sends the input to 
        /pages/profile/sections/basicDetails/main/index.tsx -> handleInputChange()
        */
        const finalVal = {
            target: {
                value: newValue?.value
            }
        }
        props.onChange(finalVal)
    };

    return (
        <div
            style={{
                width: props.width ? props.width : "100%"
            }}
        >

            {/* <div
            className="dropdown-container"
            style={{
                width: props.width ? props.width : "100%",
                position: 'relative', 
            }}
        >
            <label
                className={`dropdown-label ${true ? 'floated' : ''}`} // Add 'floated' class when value is present
                style={{
                    fontSize: props.lableFontSize ? props.lableFontSize : "16px",
                    position: "absolute",
                    top: "-11px",
                    left: "17px",
                    color: "#9e9e9e",
                    zIndex: 9,
                    background: "white"
                }}
            >
                {props.placeholder}
            </label> */}


            <Select<OptionType, false>
                options={props.options ? props.options : []}
                placeholder={props.placeholder}
                value={props.value}
                onChange={handleChange}
                styles={customStyles}
                components={customComponents}
                isSearchable={props.isDropDownSearchable ? true : false}
                isDisabled={props.readOnly}
            />
        </div>
    );
};

